import { Routes } from '@angular/router';
import { AdminGuard } from './admin.guard';
import { ErrorGuard } from './error.guard';
import { MenuGuard } from './menu.guard';
import { PlatformOwnerGuard } from './platform-owner.guard';

export const routes: Routes = [
  {
    path: 'home',
    canActivate: [ErrorGuard, MenuGuard],
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage)
  },
  {
    path: 'admin/login',
    loadComponent: () => import('./admin-login/admin-login.page').then((m) => m.AdminLoginPage)
  },
  {
    path: 'admin/products',
    canActivate: [AdminGuard],
    loadComponent: () => import('./admin-products/admin-products.page').then((m) => m.AdminProductsPage)
  },
  {
    path: 'admin/password',
    canActivate: [AdminGuard],
    loadComponent: () => import('./admin-password/admin-password.page').then((m) => m.AdminPasswordPage)
  },
  {
    path: 'admin',
    canActivate: [AdminGuard],
    loadComponent: () => import('./admin/admin.page').then( m => m.AdminPage)
  },
  {
    path: 'owner/login',
    loadComponent: () => import('./owner-login/owner-login.page').then((m) => m.OwnerLoginPage)
  },
  {
    path: 'owner',
    canActivate: [PlatformOwnerGuard],
    loadComponent: () => import('./owner/owner.page').then((m) => m.OwnerPage)
  },
  {
    path: 'barcode',
    loadComponent: () => import('./barcode/barcode.page').then( m => m.BarcodePage)
  },
  {
    path: 'order',
    canActivate: [ErrorGuard, MenuGuard],
    loadComponent: () => import('./order/order.page').then( m => m.OrderPage)
  },
  {
    path: 'status',
    canActivate: [ErrorGuard],
    loadComponent: () => import('./status/status.page').then((m) => m.StatusPage)
  },
  {
    path: 'start',
    loadComponent: () => import('./start/start.page').then( m => m.StartPage)
  },
  {
    path: '**',
    redirectTo: 'start',
    pathMatch: 'full',
  }
];
